import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MinuteApprovalParameterConstraintViewModel, MinuteApprovalParameterDTO } from '../../interfaces/minue-request-approval-paramters.interface';
import { MinuteApprovalConditionComparator } from '../../interfaces/minute-request-approval-rule.interface';

@Component({
  selector: 'app-minute-approval-condition-form-group',
  templateUrl: './minute-approval-condition-form-group.component.html',
  styleUrl: './minute-approval-condition-form-group.component.scss'
})
export class MinuteApprovalConditionFormGroupComponent implements OnInit{
  @Input() group!: FormGroup;
  @Input() parameters: MinuteApprovalParameterDTO[] = [];

  public constraintParameter: MinuteApprovalParameterConstraintViewModel | null;


  ngOnInit(): void {      
    this.group.get('parameterId')?.valueChanges.subscribe((newParameterId: number) => {
      this.updateConstraintParameter(newParameterId);
    });    
  }


  private updateConstraintParameter(parameterId: number){
    const {value, comparator} = this.group.value;
    const newParamSelected = this.parameters.find(p => p.minuteApprovalParameterId === parameterId);
    const newConstraints: MinuteApprovalParameterConstraintViewModel = {
      allowedValues: new Map(Object.entries(newParamSelected?.constraint.allowedValues).map(([k,v]) => [+k,v])),
      allowedComparators: new Map([...MinuteApprovalConditionComparator].filter(([key, _])=>  newParamSelected.constraint.allowedComparators.includes(key)))
    };

    // Avoid checking and reseting value and comparator on the first change
    if(this.constraintParameter != null){
      const resetValue: boolean = newConstraints.allowedValues.size == 0 || !newConstraints.allowedValues.has(this.group.get('value')?.value);
      const resetComparator: boolean = !newConstraints. allowedComparators.has(this.group.get('comparator')?.value);
      this.group.patchValue({
        comparator: resetComparator ? null: comparator,
        value: resetValue ? null : value
      });  
    }
    this.constraintParameter = newConstraints;

  }
}
